import React from "react";

import {
  EmptyStateAction,
  EmptyStateDescription,
  EmptyStateIcon,
  EmptyStateTitle,
  EmptyStateWrapper,
} from "./styles";
import { SectionEmptyStateProps } from "./types";

export const SectionEmptyState: React.FC<SectionEmptyStateProps> = ({
  icon,
  title,
  description,
  action,
}) => (
  <EmptyStateWrapper>
    <div>
      <EmptyStateIcon>{icon}</EmptyStateIcon>
      <EmptyStateTitle>{title}</EmptyStateTitle>
      <EmptyStateDescription>{description}</EmptyStateDescription>
      {action && <EmptyStateAction>{action}</EmptyStateAction>}
    </div>
  </EmptyStateWrapper>
);
